import {
    TRANSACTION_INSTALLMENT_TYPE_DEF_API_ERROR,
    GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    recordList: [],
    error: {}
}

const transactionInstallmentTypeDef = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload
            }
        case TRANSACTION_INSTALLMENT_TYPE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}

export default transactionInstallmentTypeDef